export enum LimitReachedType {
  wordsLimitReached = "words-limit-reach",
  imagesLimitReached = "images-limit-reach",
  requiredPaidPlan = "required-paid-plan",
}
